import React from "react";
import PropTypes from "prop-types";

import { Checkbox, Icon } from "semantic-ui-react";

import { useBooleanState } from "hooks";

function ClientCardModeToggle({ enabled, onToggle, loading }) {
  const [isHovered, setHover, resetHover] = useBooleanState();

  return (
    <div
      data-test="client-card-toggle"
      onMouseEnter={setHover}
      onMouseLeave={resetHover}
      style={{
        backgroundColor: "white",
        borderRadius: "5px",
        padding: "0.8em 1em",
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
        position: "absolute",
        bottom: "0.5em",
        right: "0.5em",
        zIndex: 99999,
        overflow: "hidden",
        minWidth: "50px",
        minHeight: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "min-width 0.3s ease-in-out",
        ...(isHovered && { minWidth: "200px" }),
      }}
    >
      <div
        style={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transform: isHovered ? "translateX(-120px)" : "translateX(0)",
          opacity: isHovered ? 0 : 1,
          transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
        }}
      >
        <Icon
          name="gem"
          size="large"
          color={enabled ? "blue" : "grey"}
          style={{ cursor: "pointer", margin: 0 }}
        />
      </div>

      <div
        style={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          transform: isHovered ? "translateX(0)" : "translateX(120px)",
          opacity: isHovered ? 1 : 0,
          transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
          whiteSpace: "nowrap",
          paddingRight: "0.5em",
        }}
      >
        <Checkbox
          toggle
          checked={enabled}
          label="Client Card Beta"
          loading={loading}
          disabled={loading}
          onChange={onToggle}
        />
      </div>
    </div>
  );
}

ClientCardModeToggle.propTypes = {
  enabled: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

ClientCardModeToggle.defaultProps = {
  enabled: false,
  loading: false,
};

export default ClientCardModeToggle;
